var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({domProps:{"value":_vm.displayValue},on:{"input":_vm.onInput}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }